import styled from 'styled-components';

const IconContainer = styled.div`
    position: absolute;
    z-index: 100;
    font-size: 2rem;
    font-variant: normal;
    line-height: 1;
    speak: none;
    text-transform: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    top: 50%;
    transform: translateY(-50%);
    left: 1.8rem;

    svg {
        color: ${(props) => props.theme.colours.grey};
    }
`;
const InputContainer = styled.div`
    opacity: 0;
    overflow: hidden;
    position: relative;
    right: 999.9rem;
    width: 0;
`;
const DatePickerLabel = styled.label`
    position: absolute;
    z-index: 100;
    cursor: pointer;
    left: 0;
    padding-left: 6rem;
    transform: translateY(-50%);
    color: ${(props) => props.theme.colours.grey};
    font-size: 1.1rem;
    line-height: 1.2;
    top: 1.5rem;
`;
const DatePickerValue = styled.label`
    position: absolute;
    z-index: 100;
    cursor: pointer;
    left: 0;
    padding-left: 5rem;
    text-align: left;
    top: 1.8rem;
    width: 100%;
    color: ${(props) => props.theme.colours.grey};
    font-family: 'Quicksand', sans-serif;
    font-weight: 500;
    font-size: 16px;
`;
export { IconContainer, InputContainer, DatePickerLabel, DatePickerValue };
